export default {
  Nav: {
    AccountInfor: 'Thông tin tài khoản',
    MyProfile: 'Hồ sơ của tôi',
    ChangePassword: 'Đổi mật khẩu',
    Logout: 'Đăng xuất',
    Tutorial: 'Hướng dẫn',
  },
  Title: {
    Dashboard: 'Demo Editor',
    CreateAdmission: 'Nộp hồ sơ',
    DetailAdmission: 'Chi tiết hồ sơ',
  },
}
